var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"-ml-3 mr-1 whitespace-no-wrap bg-green-500",attrs:{"type":"button"},on:{"click":_vm.copyHtml}},[_vm._v("\n  Copy Email Template\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }